import TypesenseInstantsearchAdapter from './TypesenseInstantsearchAdapter';

export { TypesenseInstantsearchAdapter };
export default TypesenseInstantsearchAdapter;
